import React, { useEffect } from 'react';

import { useSmartReload } from 'hooks/useSmartReload';

interface SmartReloadWrapperProps {
  children: React.ReactNode;
}

/**
 * Componente wrapper que fornece monitoramento inteligente SEM reload automático
 * Deve ser usado dentro dos providers (MenuSelectionProvider, etc.)
 */
const SmartReloadWrapper: React.FC<SmartReloadWrapperProps> = ({ children }) => {
  // Hook para monitoramento inteligente COM detecção de menu
  const { isInMeeting, stats } = useSmartReload({
    minInterval: 120000, // 2 minutos
    meetingProtection: true,
    checkInterval: 5000, // 5 segundos
    enableMenuDetection: true, // Habilita detecção por menu
  });

  useEffect(() => {
    // Monitoramento de tema SEM reload automático
    const handleVisibilityChange = () => {
      if (!document.hidden) {
        // Quando a página volta a ficar visível, apenas monitora o tema
        const bodyBackground = getComputedStyle(document.body).backgroundColor;
        const expectedBackground = 'rgb(10, 10, 10)'; // #0A0A0A

        if (bodyBackground !== expectedBackground && bodyBackground !== 'rgba(0, 0, 0, 0)') {
          console.warn(
            '[SmartReloadWrapper] Problema de tema detectado - usuário pode recarregar manualmente se necessário',
            {
              currentBackground: bodyBackground,
              expectedBackground,
              isInMeeting,
              currentMenu: stats.currentMenu,
              dynamicComponent: stats.dynamicComponent,
              timestamp: new Date().toISOString(),
            }
          );
          // SEM reload automático - apenas log para debugging
        }
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [isInMeeting, stats]);

  // Log de estatísticas para debugging (apenas em desenvolvimento)
  useEffect(() => {
    if (process.env.NODE_ENV === 'development') {
      console.log('[SmartReloadWrapper] Monitoramento Stats:', stats);
    }
  }, [stats]);

  // Este componente não renderiza nada, apenas fornece monitoramento
  return <>{children}</>;
};

export default SmartReloadWrapper;
